export function convertToTagValues(values: Array<{ id: string; name: string }>) {
  return values.map(value => ({ id: value.id, text: value.name, name: value.name }))
}
